import Vue from 'vue';
import Component from 'vue-class-component';
import { addDays } from 'date-fns';
import { Model, Prop, Watch } from 'vue-property-decorator';
import flatpickr from 'flatpickr';
import { Modal } from 'wc-lib';
import { DatePicker } from '../../date-picker';

require('../../../../icons/right.svg');

@Component({
    template: require('./panel.html'),
    components: {
        "wc-modal": Modal,
        "date-picker": DatePicker
    }
})
export class MapPanel extends Vue {
    @Prop()
    icon: string;

    @Prop()
    title: string;

    datepicker: any;

    exportGasDate: any = {
        fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        toDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
    };

    get gasDate() {
        return this.$store.getters['app/gasDate'];
    }
    currentDay: number;
    showDownloadModal: boolean = false;

    mounted() {
        this.currentDay = new Date().getDate();
        this.datepicker = flatpickr("#datePicker", {
            defaultDate: this.gasDate,
            wrap: true,
            maxDate: addDays(this.gasDate, 6),
            minDate: new Date(2018, 8, 30, 0, 0, 0, 0),
            onChange: (selectedDates, dateStr, instance) => {
                this.$store.commit('app/setGasDate', selectedDates[0]);
            },
            dateFormat: 'j M y'
        });

        setInterval(x => {
            let checkDay = new Date().getDate();
            if (checkDay !== this.currentDay) {
                this.currentDay = checkDay;
                this.datepicker.setDate(new Date(), true);
            }
        }, 60 * 1000);
    }

}


// WEBPACK FOOTER //
// src/components/map/panels/panel.ts